import { supabase } from "./core.js";

interface RateCache {
  value: number;
  ts: number;
}

let _selicCache: RateCache | null = null;
const CACHE_TTL = 5 * 60 * 1000; // 5 min

export async function fetchLatestSelic(fallback: number = 13.25): Promise<number> {
  if (_selicCache && Date.now() - _selicCache.ts < CACHE_TTL) return _selicCache.value;

  const { data, error } = await supabase
    .from("market_rates")
    .select("value")
    .eq("name", "selic")
    .order("ref_date", { ascending: false })
    .limit(1)
    .single();

  if (error || !data) return fallback;
  _selicCache = { value: data.value, ts: Date.now() };
  return data.value;
}

export async function fetchLatestPtax(fallback: number = 5.0): Promise<number> {
  const { data, error } = await supabase
    .from("market_rates")
    .select("value")
    .eq("name", "ptax")
    .order("ref_date", { ascending: false })
    .limit(1)
    .single();

  if (error || !data) return fallback;
  return data.value;
}

export async function fetchLatestIPCA(fallback: number = 4.5): Promise<number> {
  const { data, error } = await supabase
    .from("market_rates")
    .select("value")
    .eq("name", "ipca")
    .order("ref_date", { ascending: false })
    .limit(1)
    .single();

  if (error || !data) return fallback;
  return data.value;
}
